<!-- 批量审核弹窗 -->
<template>
  <el-dialog title="审核" :visible.sync="visible" width="500px" :close-on-click-modal="false" @close="handleClose">
    <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" label-position="right">
      <el-form-item label="审核结果" prop="result">
        <el-radio-group v-model="formData.result">
          <el-radio label="approve">通过</el-radio>
          <el-radio label="reject">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核意见" prop="approvalRemark" v-if="formData.result === 'reject'">
        <el-input v-model="formData.approvalRemark" type="textarea" :rows="3" placeholder="请输入驳回原因" maxlength="100"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { approveByLegal, rejectByLegal } from '@/api/invoiceManagement'

export default {
  name: 'BatchReviewDialog',
  props: {
    // 控制弹窗显示
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 签约号
    signId: {
      type: String,
      default: ''
    }
  },
  data() {
    // 审核意见验证（驳回时必填）
    const validateRemark = (rule, value, callback) => {
      if (this.formData.result === 'reject' && !value) {
        callback(new Error('请输入驳回原因'))
      } else {
        callback()
      }
    }
    return {
      visible: this.dialogVisible,
      submitLoading: false,
      formData: {
        result: 'approve',
        approvalRemark: ''
      },
      rules: {
        result: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        approvalRemark: [{ validator: validateRemark, trigger: 'blur' }]
      }
    }
  },
  watch: {
    dialogVisible(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    // 提交表单
    handleSubmit() {
      // 驳回时手动验证审核意见
      if (this.formData.result === 'reject' && !this.formData.approvalRemark.trim()) {
        this.$message.warning('请输入驳回原因')
        return
      }
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          let res
          if (this.formData.result === 'approve') {
            // 通过
            res = await approveByLegal({ signId: this.signId })
          } else {
            // 驳回
            res = await rejectByLegal({
              signId: this.signId,
              approvalRemark: this.formData.approvalRemark
            })
          }
          if (res.statusCode === 200) {
            this.$message.success('操作成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        } catch (error) {
          console.error('批量审核失败', error)
          this.$message.error('操作失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    // 取消
    handleCancel() {
      this.handleClose()
    },
    // 关闭弹窗
    handleClose() {
      this.visible = false
      this.resetForm()
    },
    // 重置表单
    resetForm() {
      this.formData = {
        result: 'approve',
        approvalRemark: ''
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  padding: 20px;
  box-sizing: border-box;
}

.selected-count {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/contractManagement/components/BatchReviewDialog.vue